// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_electronic_candle_base/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_electronic_candle_base: ModuleSchema = {
  "id": "core_electronic_candle_base",
  "uniqueId": "B3D_V1CRV",
  "createdAt": "2026-10-08T00:00:00Z",
  "updatedAt": "2026-10-09T03:28:01.916Z",
  "label": "Candle Socket",
  "description": "Smooth cylindrical reference body for sizing an electronic candle socket and optional shade mount thread.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_CND01",
    "candle",
    "socket",
    "base"
  ],
  "sliders": [
    {
      "key": "outerDiameter",
      "label": "Maximum Outer Diameter",
      "min": 40,
      "max": 120,
      "step": 1,
      "default": 65,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Base Height",
      "min": 16,
      "max": 80,
      "step": 1,
      "default": 36,
      "unit": "mm"
    },
    {
      "key": "candleDiameter",
      "label": "Electronic Candle Diameter",
      "min": 12,
      "max": 80,
      "step": 0.5,
      "default": 38,
      "unit": "mm"
    },
    {
      "key": "cavityDepth",
      "label": "Candle Socket Depth",
      "min": 4,
      "max": 70,
      "step": 0.5,
      "default": 33.5,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Minimum Socket Wall",
      "min": 1,
      "max": 10,
      "step": 0.2,
      "default": 2.4,
      "unit": "mm"
    },
    {
      "key": "bottomThickness",
      "label": "Socket Floor Thickness",
      "min": 1,
      "max": 10,
      "step": 0.2,
      "default": 2.4,
      "unit": "mm"
    },
    {
      "key": "enableMountThread",
      "label": "Enable Female Mount Thread (0/1)",
      "min": 0,
      "max": 1,
      "step": 1,
      "default": 0,
      "unit": ""
    },
    {
      "key": "mountThreadRootRadius",
      "label": "Mount Thread Root Radius",
      "min": 10,
      "max": 45,
      "step": 0.1,
      "default": 23.8,
      "unit": "mm"
    },
    {
      "key": "mountThreadCrestRadius",
      "label": "Mount Thread Crest Radius",
      "min": 10,
      "max": 45,
      "step": 0.1,
      "default": 22.7,
      "unit": "mm"
    },
    {
      "key": "mountThreadLength",
      "label": "Mount Thread Working Length",
      "min": 2,
      "max": 30,
      "step": 0.5,
      "default": 10,
      "unit": "mm"
    },
    {
      "key": "mountThreadPitch",
      "label": "Mount Thread Pitch",
      "min": 1,
      "max": 6,
      "step": 0.1,
      "default": 2.5,
      "unit": "mm"
    },
    {
      "key": "mountThreadPhase",
      "label": "Mount Thread Phase",
      "min": 0,
      "max": 6,
      "step": 0.1,
      "default": 0,
      "unit": "mm"
    },
    {
      "key": "mountThreadFadeTurns",
      "label": "Thread End Fade",
      "min": 0,
      "max": 1,
      "step": 0.05,
      "default": 0.4,
      "unit": "turns"
    },
    {
      "key": "mountThreadLeadInHeight",
      "label": "Female Mouth Lead-in",
      "min": 0,
      "max": 4,
      "step": 0.1,
      "default": 2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Candle Base",
      "default": "#10b981",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "electronic_candle_base_obj",
      "label": "Electronic Candle Socket Core",
      "name": "Electronic Candle Socket Core",
      "parts": [
        {
          "id": "electronic_candle_base",
          "label": "Electronic Candle Socket Core",
          "name": "Electronic Candle Socket Core",
          "groupId": 0,
          "colorKey": "base",
          "defaultColor": "#10b981",
          "previewQuality": "medium",
          "exportQuality": "high",
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Electronic Candle Base",
      "groupId": -1
    }
  ]
};
